import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import {
  ButtonComponent,
  SharedModule as LciCoreShared
} from '@lciapps/lci-core';
import { AuthNavComponent } from './components/auth-nav.component';
import { GenericDialogComponent } from './components/generic-dialog/generic-dialog.component';

@NgModule({
  imports: [
    LciCoreShared,
    CommonModule,
    MatDialogModule,
    MatIconModule,
    RouterModule
  ],
  declarations: [AuthNavComponent, GenericDialogComponent],
  entryComponents: [GenericDialogComponent],
  exports: [AuthNavComponent, ButtonComponent]
})
export class SharedModule { }
